import React, { useState, useEffect, useRef, useContext } from "react";
import Container from "react-bootstrap/Container";
import "./Header.css";
import Logo from "../../Images/logo.png";
import HumbargerIcon from "../../Images/HumbargerIcon.png";
import { Row, Col } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import MobileNav from "./MobileNav";
import LoginMenu from "./LoginMenu";
import { useSelector, useDispatch } from 'react-redux';

import { userSelector, clearState, fetchUserBytoken, setState } from '../features/User/UserSlice';
import LoginPopup from "../CommonUI/LoginPopup/LoginPopup";
import URLstateContext from "../../provider/CommonContext";
import TickerTape from "./TickerTape";

import userarrowdown from "../../Images/user-arrowdown.png";
import Avatar from 'react-avatar';
import { Helmet } from 'react-helmet-async';
import {
    FaAngleDown
} from "react-icons/fa";
import TrackApi from "../Activity_Track/TrackApi";
import { useCookies } from "react-cookie";
import { Apiurl } from "../Configuration/configuration";
import CallTrackApi from "../Activity_Track/CallTrackApi";
import axios from "axios";
import WebZoomColorAudio from "../../Components/Header/webzoomcoloraudio/webzoomcoloraudio";


function Header() {
    const { BaseURL, setcompserachcocode } = useContext(URLstateContext);
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const childRef = useRef(null);
    const { clientId } = useContext(URLstateContext);
    const [showResults, setShowResults] = useState(false);
    const [setTextval, setText] = useState([])
    const [suggestions, setSuggestions] = useState([]);
    const [avatarimg, setavatarimg] = useState(false);
    const [cookies, setCookie] = useCookies(['LeadId']);

    const marqueetext =
        "As per guidelines, it is mandatory to link your PAN with Aadhaar before 31st March’23 to continue trading.";
    const { isFetching, isSuccess, isError, errorMessage } = useSelector(
        userSelector
    );
    // one change
    const dispatch = useDispatch();

    //header changes
    let locationUrl = window.location;
    let StockUrl = window.location.pathname.split('/stocks/')[1];
    // alert(StockUrl)
    let strStockUrl = StockUrl;
    strStockUrl = strStockUrl;
    // alert(strStockUrl);
    useEffect(() => {

        postData(`${Apiurl}/api/Login/keywordtitle/`, { "sectionname": locationUrl.pathname })
            .then((data) => {
                if (data.data != null && data.data.length > 0) {
                    setData(data.data);
                    // setMapdata(data.data)
                    // console.log("data_all: ", data)

                }
                else { setData(null); }
            });
    }, []);

    useEffect(() => {
        if (localStorage.getItem('token') != undefined){
        //     const em=localStorage.getItem('email');
        //     const nm= localStorage.getItem('name');
        //     const ProspectStage=localStorage.getItem('ProspectStage');
        //     const mx_Lead_Status=localStorage.getItem('mx_Lead_Status');
        //    const mx_Status= localStorage.getItem('mx_Status');
        //     // dispatch(fetchUserBytoken({ token: localStorage.getItem('token') }));
        //     dispatch(setState({
        //         "email": em,
        //         "name": nm,
        //         "ProspectStage": ProspectStage,
        //         "mx_Lead_Status":mx_Lead_Status,
        //         "mx_Status":mx_Status
        //     }));
        
            // if(isSuccess){
                // alert("jjj");
                const numberold=localStorage.getItem('email');
                const nameold=localStorage.getItem('name');
                axios.post(`https://www.moneysukh.com/signupRetriveLead`,{"phone":numberold}).then((res)=>{
        console.log("ssssssssssss",res && res.data);
        
            if(res && res.data.length>0){
            dispatch(setState({
                "email": numberold,
                "name": nameold,
                "ProspectStage": res.data[0].prospectStage,
                "mx_Lead_Status": res.data[0].mx_Lead_Status,
                "mx_Status": res.data[0].mx_Status
            }));  
            //  
            const leadId=res.data[0].prospectID;
               setCookie('RelatedProspectId', leadId,{ path: '/',"maxAge": 2592000*3 });
               const payloadData={
                "RelatedProspectId":leadId,
                "ActivityNote": "Your Activity Note",
                "mx_Custom_1": "Home",
                "mx_Custom_2": "Your Activity Note",
                "mx_CustomObject_81":window.location.href
               }
            //    TrackApi(payloadData);
        }
        
        }).catch((error)=>{
            console.log(error);
        })
    // }    
        
        }
    }, [isSuccess, isError]);

    const { username, email, imgurl } = useSelector(userSelector);

    useEffect(() => {
        if (username != "") {
            //console.log("imgurl:" + imgurl);
            if (imgurl == "") {

                setavatarimg(true);
            }
            else {
                setavatarimg(false);
            }
        }
    }, [username, imgurl]);

    const onLogOut = () => {
        localStorage.removeItem('token');

    };
    const [showText, setShowText] = useState(false);
    const [loginmenudiv, setloginmenu] = useState(false);
    const clickHanlder = () => setShowText(true);
    const clickHanlderlogin = () => setloginmenu(true);
    const searchBox = "Type to search ";
    useEffect(() => {
        window.addEventListener("scroll", isSticky);
        return () => {
            window.removeEventListener("scroll", isSticky);
        };
    });
    const isSticky = (e) => {
        const header = document.querySelector(".header-section");
        const scrollTop = window.scrollY;
        scrollTop >= 150
            ? header.classList.add("is-sticky")
            : header.classList.remove("is-sticky");
    };
    const clickToggleLoginPopup = (showhide) => {
        childRef.current.changeTogglePopup(showhide);
    }

    //header changes

    async function postData(url = '', data = {}) {

        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header

        });
        // console.log(response, "careerdata");
        return response.json(); // parses JSON response into native JavaScript objects

    }
    // document.querySelector('.inner').addEventListener('mouseenter', function() {
    //       mouseEntered = true;
    //  })

    let DataFilter = [];
    let getval = [];
    let matchcomp = [];
    function Loadcompany(setTextval) {
        setShowResults(true);
        const getSectorListUrl = BaseURL + "companysearch/" + setTextval;
        //console.log("getSectorListUrl+" + getSectorListUrl)
        fetch(`${getSectorListUrl}`)
            .then((response) => response.json())
            .then((data) => {
                const myrepo = data.data;
                // console.log(JSON.stringify(myrepo))
                getval = myrepo;
                for (var i = 0; i < getval.length; i++) {
                    // alert("hh")
                    DataFilter.push({
                        CompName: getval[i]['lname'],
                        COCODE: getval[i]['Co_Code'],
                        Exchange: getval[i]['Exchange']
                    });
                }
                //console.log("DataFilter : " + JSON.stringify(DataFilter))
                // setSuggestions(DataFilter);
                matchcomp = DataFilter;
                setSuggestions(matchcomp);
                //console.log("suggestions : " + JSON.stringify(suggestions))
                // console.log("getval : "+JSON.stringify(getval))
                // setcompanysearch(myrepo);
                // console.log(JSON.stringify(companysearch))
                // getcompanydata();
                //console.log(getData);
            })
            .catch((error) => {
                //  console.log(error);
            });
    }
    const onSuggestHandler = event => { setSuggestions([]) }
    const getselectedcompany = (event, param) => { }
    const onChangeHandler = event => {
        let matches = [];
        setText(event.target.value);
        var nameComp = event.target.value;
        if (nameComp.length > 1) {
            Loadcompany(setTextval);
        }
        else {
            setShowResults(false);
            DataFilter = [];
            setSuggestions(DataFilter);
        }
    };
    const companyClick = (paramcode, paramname, paramexchange) => {
        setShowResults(false);
        //setcocode(paramcode);
        //setcompserachcocode(paramcode);
        // navigate("/CompanySnapshot/" + 'nse' + "/" + paramcode + "/" + paramname, {
        //navigate("/stocks/" + paramname.replace(/ /g, '-').replace('&', 'and').replace('+', ''), {
        //});
        document.getElementById('compText').value = paramname;
        window.location.href = "/stocks/" + paramname.replace(/ /g, '-').replace('&', 'and').replace('+', '').replace(/\./g,'').toLowerCase();
    }
    const trackData=(id,url)=>{
        const payloadData={
          "RelatedProspectId":id,
          "ActivityNote": "support page visit",
          "mx_Custom_1": "Support",
          "mx_Custom_2": "Your support Note",
          "mx_CustomObject_81":url
         }
         TrackApi(payloadData);
      }
      const trackDataLogin=(id,url)=>{
        const payloadData={
          "RelatedProspectId":id,
          "ActivityNote": "Trade login visit",
          "mx_Custom_1": "Trade login",
          "mx_Custom_2": "Trade login Note",
          "mx_CustomObject_81":url
         }
         TrackApi(payloadData);
      }
const TrackSupport=(url)=>{
    if(cookies && cookies.RelatedProspectId){
        trackData(cookies.RelatedProspectId,url);
      }   
}
const TrackLogin=(url)=>{
    if(cookies && cookies.RelatedProspectId){
        trackDataLogin(cookies.RelatedProspectId,url);
      }   
}

    return (
        <>
            {(window.location.pathname.split('/')[1] == "stocks") ?
                <Helmet>
                    {/* <title>Moneysukh - Online Share Trading & Best Trading Platform in India</title> */}
                    <title>{strStockUrl.replace(/-/g, ' ')} Stock Price Live,Today NSE/BSE  |Moneysukh </title>
                    <meta name="description" content={strStockUrl.replace(/-/g, ' ') + " " + "share price along with the stocks news, fundamentals, technicals, company profile, Market Capital, Share holding, annual, quarterly results, profit and loss"} />
                    <meta name="keywords" content={strStockUrl.replace(/-/g, ' ') + " " + "Share Price," + " " + strStockUrl.replace(/-/g, ' ') + " " + " Stock Price, Quote," + " " + strStockUrl.replace(/-/g, ' ') + "News," + " " + strStockUrl.replace(/-/g, ' ') + " " + "chart, graph, volumes," + " " + strStockUrl.replace(/-/g, ' ') + " " + "52-week high low," + " " + strStockUrl.replace(/-/g, ' ') + " " + "bid price, bid quantity, offer price, offer quantity, intraday," + " " + strStockUrl.replace(/-/g, ' ') + " " + "NSE/BSE Forecast News and Live Quotes " + " " + strStockUrl.replace(/-/g, ' ') + " " + "Analysis, Annual Report," + " " + strStockUrl.replace(/-/g, ' ') + " " + "profit and loss," + " " + strStockUrl.replace(/-/g, ' ') + " " + "Market Capital, stock price for" + " " + strStockUrl.replace(/-/g, ' ') + " " } />
                </Helmet> :
                <Helmet>

                    {(window.location.pathname).split('/')[1] != "report" && (data == null) ?
                        <><title>Moneysukh - Online Share Trading & Best Trading Platform in India</title>
                            <meta name="description" content="Moneysukh offers best online trading platform. Start investing in equities, commodities, Trade In Future & Options at ₹10/order Top Algo Trading Platforms" />
                            <meta name="Keywords" content="Open Demat & Trading account just 5 min, online stock trading, stock trading,     best trading platform, online stock trading, discount broker, discount brokerage, algorithmic trading,Algo trading, Top Algo Trading Platforms, stock market, lowest brokerage rates for futures and options,            best discount broker, Get option strategies & Screeners, Free research advisory." /></> :
                        data && data.map(({ title, keywords, description, heading }) => {
                            return <>
                                <title>{title}</title>
                                <meta name='heading' content={heading} />
                                <meta name='keywords' content={keywords} />
                                <meta name='description' content={description} />
                            </>
                        })
                    }
                </Helmet>


            }
            <TickerTape />
          
            <WebZoomColorAudio />

            <header className="header-section">
                <Container>
                    <Row className="align-items-center">
                        {showText ? <MobileNav closeNav={setShowText} /> : null}
                        {loginmenudiv ? <LoginMenu closeNav={setloginmenu} username={username} email={email} imgurl={imgurl} clientId={clientId} avatarimg={avatarimg} /> : null}
                        <Col xs={6} sm={4} md={2} className="rightLeftZero">
                            <Nav.Link href="/">
                                <img src={Logo} className="img-fluid Logo" alt="Logo"/>
                            </Nav.Link>

                        </Col>
                        <Col md={5.5} className="hide-767-menu">
                            <Nav className="menubody">
                                <Nav.Item>
                                    <Nav.Link className="menutextcolor" href="/About">
                                        About Us
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link className="menutextcolor" href="/Product">
                                        Products
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link className="menutextcolor" href="/market/event-tracker">
                                        Markets
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link className="menutextcolor" href="/Pricing">
                                        Pricing
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link
                                        className="menutextcolor"
                                        href="https://support.moneysukh.com/"
                                        target="_blank"
                                        onClick={()=>TrackSupport("https://support.moneysukh.com/")}
                                    >
                                        Support
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Col>
                        <Col xs={12} sm={8} md={5}>
                            <div className="searchloginhumbrg_grid">
                                <div className="SearchBox">

                                    <input id="compText"
                                        type="text"
                                        placeholder={searchBox}
                                        onChange={onChangeHandler}
                                        className="SearchBox"
                                    />
                                     {showResults ?
                                    <div className="new">
                                        {suggestions && suggestions.map((suggestion, i) =>
                                            <div className="suggestion col-md-12 justify-content-md-center padd-content" onClick={() => companyClick(suggestion.COCODE, suggestion.CompName, suggestion.Exchange)}>{suggestion.CompName}</div>
                                        )}
                                    </div> :''}

                                </div>
                                <div className={isSuccess ? 'login-buttonDivSession' : 'login-buttonDiv'} >
                                    <div className="loginsignupbtn_group" style={{ display: !isSuccess ? 'flex' : 'none' }}>
                                        {/*<button type="button" className="Login-Button end-0">
                                          <a href="https://online.moneysukh.com/" target="_blank">Login</a>
                                      </button> */}
                                        
                                        {/* old login */}
                                        {/* <button type="button" className="Login-Button end-0">
                                            <a href="https://online.moneysukh.com/">Login</a>
                                            <a href="https://online.moneysukh.com/"  onClick={()=>TrackLogin("https://online.moneysukh.com/")}>Login</a>
                                        </button> */}

                                        {/* New login button */}
                                        <span type="button" className="Login-Button end-0 text-center">
                                            {/* <a href="https://online.moneysukh.com/">Login</a> */}
                                            <a href="https://online.moneysukh.com/"  onClick={()=>TrackLogin("https://online.moneysukh.com/")}>Login</a>
                                        </span>

                                        <button type="button" onClick={() => clickToggleLoginPopup(true)} className="Login-Button signup_btn end-0">
                                            Sign Up
                                        </button>
                                    </div>
                                    <div className="user_profile" onClick={clickHanlderlogin} style={{ display: isSuccess ? 'block' : 'none' }}>
                                        <div className="usernameimg_panel media">

                                            <div style={{ avatarimg: isSuccess ? 'block' : 'none' }} className="usernameimg_panel media">
                                                <span className="user_fname">{username != null ? username.substring(0, 1) : ''}</span>
                                                <span className="userfname_icon media-body">
                                                    <img src={userarrowdown} className="userarrowdown" />
                                                </span>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                                        
                                 {/* alt="HumbargerIcon"  */}
                                <div className="HumbargerIconDiv" onClick={clickHanlder}>
                                    <img src={HumbargerIcon} className="HumbargerIcon" alt="HumbargerIcon" />
                                </div>
                            </div>
                        </Col>
                    </Row>

                </Container>
            </header>
            <LoginPopup show={show} ref={childRef} />
            {/*<div className="oldwebsite_panel">
              <a href="http://www.mansukh.net/" target="_blank"><span className="oldsite">Switch to old website </span></a>
          </div>*/}
        </>
    );
}

export default Header;